import axios from "axios";

/*
Site Oficial API: https://www.cnpj.ws/pt-BR?gad_source=1&gclid=CjwKCAjwktO_BhBrEiwAV70jXtpiIHnHefpWOu6UPc8Pwp9T55lNdLN2TBiv4T6nd7mB
Permite 3 consultas por minuto no modo gratuito
*/

export default {
    getCNPJ(cnpj){
        return axios.get(`https://publica.cnpj.ws/cnpj/${cnpj}`)
    }
}
